import type { CakeLevel } from "./engine";

/**
 * Difficulty curve for the Cake Merge campaign. It starts with just two cake
 * colors (as the original does) and gradually introduces more, with rising cake
 * targets and slightly bigger boards.
 */
export function cakeCampaign(count: number): CakeLevel[] {
  const levels: CakeLevel[] = [];
  for (let n = 1; n <= count; n++) {
    const colors = Math.min(6, 2 + Math.floor((n - 1) / 5));
    const big = n >= 14;
    levels.push({
      cols: 4,
      rows: big ? 6 : 5,
      colors,
      target: 6 + Math.floor(n * 1.4),
      trayMin: 2,
      trayMax: n < 6 ? 3 : 4,
      boosters: 3,
    });
  }
  return levels;
}

export const CAKE_LEVELS: CakeLevel[] = cakeCampaign(40);
